import { useState } from 'react';
import { Icon } from '@iconify/react';
import cx from 'classnames';
import Tooltip from '../../components/Tooltip';
import chevronUp from '@iconify/icons-akar-icons/chevron-up';
import chevronDown from '@iconify/icons-akar-icons/chevron-down';
import styles from './Table.module.scss';

interface Props {
  columns: {
    label: string;
    accessor: string;
    sortable: boolean;
    tooltip?: string;
  }[];
  handleSorting: any | ((accessor: string, sortOrder: string) => void);
}
const TableHead = ({ columns, handleSorting }: Props): JSX.Element => {
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState('asc');

  const handleSortingChange = (accessor: string) => {
    const sortOrder = accessor === sortField && order === 'asc' ? 'desc' : 'asc';
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  };

  return (
    <thead>
      <tr>
        {columns &&
          columns.map(({ label, accessor, sortable, tooltip }) => {
            const cl = sortable
              ? sortField === accessor && order === 'asc'
                ? 'up'
                : sortField === accessor && order === 'desc'
                  ? 'down'
                  : 'default'
              : '';
            return (
              <th key={accessor}>
                {label}

                {sortable ? (
                  <div className={styles.tableHeadArrowIcons} onClick={() => handleSortingChange(accessor)}>
                    <Icon className={cx(styles.icon, styles[cl])} icon={chevronUp} />
                    <Icon className={cx(styles.icon, styles[cl])} icon={chevronDown} />
                  </div>
                ) : null}
                {tooltip && (
                  <Tooltip
                    content={tooltip}
                    direction='top'
                    translateTooltip={{ transform: 'translate(17px, -12px)' }}
                    color='white'
                    maxWidth='80px'
                  >
                    <p className={styles.tooltipIcon}>?</p>
                  </Tooltip>
                )}
              </th>
            );
          })}
      </tr>
    </thead>
  );
};

export default TableHead;
